import { ItemizedAverageScoreData, ParticipationQuarterArea } from "./types";
import { AggregatedReport } from "../useHydratedCubeData/types";

export function clamp01(value: number) {
  return Math.max(0, Math.min(1, value));
}

export function getConsentItemsDistribution(items: number[]) {
  const distribution: Record<ParticipationQuarterArea, number> = {
    "strong-rejection": 0,
    "weak-rejection": 0,
    "weak-consent": 0,
    "strong-consent": 0,
  };

  if (items.length === 0) {
    return distribution;
  }

  items.forEach(item => {
    // Ensure item is within 0-1 range
    const normalizedItem = clamp01(item);

    if (normalizedItem < 0.25) {
      distribution["strong-rejection"]++;
    } else if (normalizedItem < 0.5) {
      distribution["weak-rejection"]++;
    } else if (normalizedItem < 0.75) {
      distribution["weak-consent"]++;
    } else {
      distribution["strong-consent"]++;
    }
  });

  const total = items.length;
  distribution["strong-rejection"] /= total;
  distribution["weak-rejection"] /= total;
  distribution["weak-consent"] /= total;
  distribution["strong-consent"] /= total;

  return distribution;
}

export function getQualityImportanceItems(
  xImportanceItems: number[],
  yQualityItems: number[]
) {
  const minLength = Math.min(xImportanceItems.length, yQualityItems.length);
  return Array.from({ length: minLength }, (_, i) => ({
    x: clamp01(xImportanceItems[i]),
    y: clamp01(yQualityItems[i]),
  }));
}

export function getItemizedAverageScoreData(
  aggregatedReports: (AggregatedReport | null)[]
) {
  const filteredReports = aggregatedReports.filter(
    (report): report is AggregatedReport => report !== null
  );
  return filteredReports.reduce<ItemizedAverageScoreData[]>(
    (acc, { averageScore }) => {
      const scores = averageScore.questions.map<ItemizedAverageScoreData>(
        question => {
          return {
            questionTitle: question.text,
            participationQuarterAreaItems: getConsentItemsDistribution(
              question.questionEntries
            ),
            averageScore: question.average ?? 0,
          };
        }
      );

      return [...acc, ...scores];
    },
    []
  );
}
